import {
  createWatermark as createBaseWatermark,
  type WatermarkInstance,
  type WatermarkLifecycleEvent,
  type WatermarkOptions,
} from 'lucky-watermark'
// import { reportWithLuckyTrack } from 'lucky-track-report'

const WATERMARK_EVENT_TYPE = 'watermark_lifecycle'

const WATERMARK_EVENT_CODE_MAP: Record<WatermarkLifecycleEvent['type'], string> = {
  created: 'watermark_created',
  updated: 'watermark_updated',
  restored: 'watermark_restored',
  removed: 'watermark_removed',
}

// const reportWatermarkLifecycle = (event: WatermarkLifecycleEvent) => {
//   const content = event.options.content;
//   let appName = '';
//   let user = '';
//   let pageUrl = location.href;

//   if (Array.isArray(content)) {
//     [appName, user, pageUrl] = content;
//   }

//   return reportWithLuckyTrack({
//     event: {
//       event_code: WATERMARK_EVENT_CODE_MAP[event.type],
//       event_type: WATERMARK_EVENT_TYPE,
//       properties: {
//         content: event.options.content,
//         appName,
//         user,
//         pageUrl,
//         version : '1.0.7',
//       },
//     },
//   })
// }

export const createWatermark = (options: WatermarkOptions): Promise<WatermarkInstance> => {
  // return createBaseWatermark(options, reportWatermarkLifecycle)
  return createBaseWatermark(options)
}

// export { reportWithLuckyTrack }

export type { WatermarkOptions, WatermarkInstance }

export default {
  createWatermark,
}
